import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import styles from "./signupButton.module.css";
import { useMyContext } from "../../myContext";

const CommonButton = ({
  classes,
  title,
  disabled,
  onClick,
  tabIndex,
  loading,
  padding,
  width,
}) => {
  const { themeColor, loadingLogo } = useMyContext("");
  return (
    <>
      {loadingLogo ? (
        <Button
          className={`${styles.button} ${classes} ${
            title === "Next" && styles.buttonmargin
          }`}
          style={{
            backgroundColor: themeColor,
            padding: padding,
            width: width,
          }}
          tabIndex={tabIndex}
          disabled={disabled}
          onClick={onClick}
        >
          {loading && (
            <Spinner
              animation="border"
              className={styles.spinnerColor}
              style={{ borderColor: themeColor, borderRightColor: "white" }}
            />
          )}
          {title}
        </Button>
      ) : (
        ""
      )}
    </>
  );
};

export default CommonButton;
